import React from "react";

const Footer = () => {
  return (
    <section class="container-fluid footer">
      <div class="row">
        <p>&copy; 2025 Parul University. All rights reserved.</p>
      </div>
    </section>
  );
};

export default Footer;
